//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cms from '~/mixins/cms';

export default {
  cmsId: 'cargo-sales-agents',
  name: 'cargo-sales-agents',
  platforms: ['CABINET'],
  access: '*',
  mixins: [cms],
  computed: {
    selection () {
      return this.publicPage.selection || {};
    },
    selectedCountry () {
      return this.selection.country;
    },
    selectedCity () {
      return this.selection.city;
    },
    title () {
      return this.content.heading;
    },
    mobileTitle () {
      return this.content.mobileHeading || this.content.heading;
    },
    countryOptions () {
      return this.publicPage.options?.countries || [];
    },
    cityOptions () {
      return this.publicPage.options?.cities || [];
    },
    selectedAgents () {
      return this.content.items || [];
    },
  },
  methods: {
    selectCountry (country) {
      if (!country || country === this.selectedCountry) {
        return;
      }
      this.$router.push({ query: { country } });
    },
    selectCity (city) {
      if (city && city !== this.selectedCity) {
        this.$router.push({
          query: {
            country: this.selection.country,
            city,
          },
        });
      }
    },
    getMapUrl (agent) {
      const address = agent.address || agent.title;
      const city = this.cityOptions.find(option => option.value === this.selectedCity);
      const country = this.countryOptions.find(option => option.value === this.selectedCountry);
      const query = [address, city?.label, country?.label]
        .filter(Boolean)
        .join(', ');
      return `https://yandex.ru/maps/?text=${encodeURIComponent(query)}`;
    },
    getPhoneUrl (phone) {
      const number = phone.split(',')[0].replace(/[^+\d]/g, '');
      return `tel:${number}`;
    },
  },
};
